"use strict";

define('rs/form/formobjects/empty/empty.formobject',['rs/form/formobjects/base.formobject', 'rs/form/formobjects/empty/empty.formobject.view'], function (BaseFormObject, EmptyFormObjectView) {
  var EmptyFormObject = BaseFormObject.extend({
    isEmptyObject: true,
    propertiesDefinitions: [],
    linksDefinitions: [],
    initialize: function initialize() {
      this.name = '@';
      this._super.apply(this, arguments);
    },
    setupView: function setupView() {
      this.setView(new EmptyFormObjectView());
    },
    canBeLinkedFromFormObject: function canBeLinkedFromFormObject(fo) {
      return false;
    },
    requestTypeInsertAtIndex: function requestTypeInsertAtIndex(type, index) {
      this.getFormController().newFormObjectByType(type, this.getSectionController(), index);
    },
    requestTypeInsertAtEnd: function requestTypeInsertAtEnd(type) {
      this.getFormController().newFormObjectByType(type, this.getSectionController(), this.getSectionController().getChildren().length);
    },
    requestInsertAtIndex: function requestInsertAtIndex() {
      this.getSectionController().requestInsertAtIndex.apply(this.getSectionController(), arguments);
    },
    requestInsertAtEnd: function requestInsertAtEnd() {
      this.getSectionController().requestInsertAtEnd.apply(this.getSectionController(), arguments);
    }
  });
  return EmptyFormObject;
});

